const isAnchor = (str) => str.trim() === '#';

export default isAnchor;
